import { appConstants } from "../constants/appConstants"

const initialState = {
  drawerAppointments: null,
  refreshAppointments: null,
  componentData: null,
  isConsultantsViewShown: null,
}

const drawerReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case appConstants.DRAWER_APPOINTMENTS:
      return { ...state, drawerAppointments: action.data }
    case appConstants.REFRESH_APPOINTMENTS:
      return { ...state, refreshAppointments: action.data }
    case appConstants.COMPONENT_DATA:
      return { ...state, componentData: action.data }
    case appConstants.DISPLAY_CONSULTANTS_IN_DRAWER:
      return { ...state, isConsultantsViewShown: action.data }
    case appConstants.RESET:
      return { ...initialState }
    default:
      return { ...state }
  }
}

export default drawerReducer
